import { PAGE_ICONS } from "@congrs/schemas";
import { Ionicon } from "./Ionicon";
import { Select } from "react-hook-form-mantine";
import { Group, Text, Flex } from "@mantine/core";

const iconOptions = PAGE_ICONS.map((icon) => ({
  value: icon,
  label: icon
    .split("-")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" "),
}));

const IconSelect = ({ currentIcon, ...props }) => {
  const renderIconOption = ({ option }) => {
    return (
      <Group>
        <Ionicon name={option.value} />
        <Text>{option.label}</Text>
      </Group>
    );
  };

  return (
    <Flex align="center" gap="xs">
      <Ionicon
        name={currentIcon}
        size={40}
        styles={{ root: { marginTop: 24, paddingLeft: 8 } }}
      />
      <Select
        style={{ flex: 1 }}
        label="Icon"
        placeholder="Select icon"
        searchable
        clearable={false}
        allowDeselect={false}
        limit={50}
        data={iconOptions}
        renderOption={renderIconOption}
        {...props}
      />
    </Flex>
  );
};

export default IconSelect;
